import { cloneDeep, isEqual } from 'lodash'

import { Colors, getString } from '@sigma-frontend-libs/commons'

import { buttonModes, icons } from '@/utils'

import render from './render'

export default {
  name: 'ConfirmButton',

  props: {
    value: null,

    title: [ String, Number, Boolean ],
    label: [ String, Number, Boolean ],

    icon: {
      type: String,
      default: icons.done,
      validator: value => {
        return Object.values(icons).includes(value)
      }
    },
    mode: {
      type: String,
      default: buttonModes.flat,
      validator: value => {
        return Object.values(buttonModes).includes(value)
      }
    },
    color: {
      type: String,
      default: Colors.success,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    },

    dialog: Boolean,
    loading: Boolean,
    disabled: Boolean
  },

  data() {
    return {
      proxy: cloneDeep(this.value),

      showDialog: false
    }
  },

  computed: {
    $_title() {
      if (this.title) {
        return getString(this.title)
      }
    },
    $_label() {
      if (this.label) {
        return getString(this.label)
      }
    },

    $_disabled() {
      return this.loading || this.disabled || isEqual(this.proxy, this.value)
    }
  },

  methods: {
    emitInput() {
      this.proxy = cloneDeep(this.value)
      this.$emit('input', this.value)
    }
  },

  render
}
